import React, { Component } from 'react';

class About extends Component {
  render() {
    return (
      <div className="condiv">
        <h1 className="subtopic">About Me</h1>
        <h4>Hey there,</h4>
        <h1>I'm Temitayo Adeleke</h1>
        <h3>Full Stack Web <u>Developer</u></h3>
        <br></br>
        <p>
        I'm an enthusiast web developer who has devoted every day since I have graduated from college to my passion:
programming and software development.
        </p>
      </div>
    )
  }
}
export default About